// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__12X86","tab":"Tabs_tab__1a2Yw","tabActive":"Tabs_tabActive__ztZcW"};